import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { JanelaDeMenu, PrivilegioResponseDTO } from '../../models/privilegio.model';
import { PrivilegioDTO } from '../../models/privilegio.model';

@Injectable({
  providedIn: 'root',
})
export class PrivilegioService {
  constructor(private apiService: ApiService) {}

  get(url: string, data?: any): Observable<PrivilegioResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<PrivilegioResponseDTO>(path);
  }

  /**
   * Retorna todos os valores do enum JanelaDeMenu (os 20 valores),
   * independente de existirem registros no banco de dados.
   */
  getJanelasDeMenu(): Observable<JanelaDeMenu[]> {
    return this.apiService.read<JanelaDeMenu[]>('/enums/janelaDeMenu');
  }
  getById<T>(url: string): Observable<PrivilegioDTO> {
    return this.apiService.read<PrivilegioDTO>(url);
  }

  post<T>(url: string, data: PrivilegioDTO): Observable<PrivilegioDTO> {
    return this.apiService.create<PrivilegioDTO>(url, data);
  }

  put<T>(url: string, data: PrivilegioDTO): Observable<PrivilegioDTO> {
    return this.apiService.update<PrivilegioDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
